import { ADD_TO_QUEUE, SAVE_QUEUE } from '../actions/actionsQueue'
import { changesDB } from '../../firestoreDB'
// import * as Sentry from '@sentry/vue'
// import { _ } from 'vue-underscore'
import firebase from 'firebase'
import { apiCall } from '@/utils/api'
const getDefaultState = () => ({
  queue: {}
})

const state = getDefaultState()

const getters = {
  getQueue: state => state.queue
}

const actions = {
  [ADD_TO_QUEUE]: ({ commit, state, getters, dispatch }, values) => {
    return new Promise((resolve, reject) => {
      const {
        key = '',
        fieldsName = [],
        action = 'updated',
        currentScreen = 'publications'
      } = values
      const totalPath =
        currentScreen === 'users'
          ? `users:${getters.firebaseUUID()}`
          : `users:${getters.firebaseUUID()}:${currentScreen}:${key}`
      const nowDate = firebase.firestore.Timestamp.fromDate(new Date())
      const setValues = {
        fields: fieldsName,
        action: action,
        updated_at: nowDate
      }
      changesDB
        .doc(totalPath)
        .get()
        .then(doc => {
          if (doc.exists) {
            changesDB
              .doc(totalPath)
              .update(setValues)
              .then(
                result => {
                  commit(SAVE_QUEUE, setValues)
                }
              )
          } else {
            changesDB
              .doc(totalPath)
              .set({ ...setValues, created_at: nowDate })
              .then(
                result => {
                  commit(SAVE_QUEUE, { ...setValues, created_at: nowDate })
                }
              )
          }

          apiCall({
            url: '/api/v1.0/firebase/notify-changes',
            data: {change_id: totalPath},
            method: 'POST'
          })
        })
      resolve(true)
    })
  }
}

const mutations = {
  [SAVE_QUEUE]: (state, queueData) => {
    state.queue = queueData
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/actionsQueue.js